import { render } from "./pl35-bai.vue?vue&type=template&id=49bb7e0a&scoped=true"
import script from "./pl35-bai.vue?vue&type=script&lang=js"
export * from "./pl35-bai.vue?vue&type=script&lang=js"

import "./pl35-bai.vue?vue&type=style&index=0&id=49bb7e0a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bb7e0a"]])

export default __exports__